module.exports = __webpack_public_path__ + "img/bar_02.ea961fee.webp";